import React from 'react';
import propTypes from "prop-types";

const  ExternalIcon = ({children, ...rest}) => {

  return  (
    <a href="https://www.acf.hhs.gov/disclaimers" target="_blank" rel="noreferrer" aria-label="View disclaimers page in a new window">
        <svg
            className={`usa-icon ${rest.iconColor}`}
            xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24"><path d="M19 19H5V5h7V3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"/>
        </svg>
    </a>
  )
};

export default ExternalIcon;
ExternalIcon.propTypes = {
  iconColor: propTypes.oneOfType([propTypes.string])
}
ExternalIcon.defaultProps = {
  iconColor: "black",
}
